import { borderRadius, customScrollMinimal } from '@toggle/design-system';
import styled from 'styled-components';

export const DropdownContainer = styled.div`
  width: 480px;
  max-height: 780px;
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  background-color: var(--background-soft);
  ${borderRadius.r2};
`;

export const ContentWrapper = styled.div`
  overflow-y: auto;
  min-height: 0;
  ${customScrollMinimal};
`;

export const SkeletonLoaderWrapper = styled.div`
  height: 90px;
  padding: 0 16px 16px 16px;
`;

export const PaginationLoaderWrapper = styled.div`
  padding: 12px 20px;
`;
